import { makeStyles } from "@material-ui/core";
import { format } from "date-fns";
import {
  getDateTimeFormats,
  getDateTimeLocale,
} from "../../../../../../utils/get-date-time-locale";
import { useTranslation } from "react-i18next";

import React, { useMemo } from "react";
import { finalDeliberations } from "../../../../../../services/formCombos.service.js";
import {
  Action,
  Comment,
  Header,
  Info,
  InfoContainer,
  InitialRegisterTitle,
  ReviewsContainer,
} from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    minWidth: 180,
    minHeight: 50,
    borderRadius: 25,
    marginTop: "5vh",
  },
  spacer: {
    marginBottom: 20,
  },
  success: {
    backgroundColor: theme.palette.success.dark,
    borderRadius: 5,
    height: 50,
  },
  label: {
    ...theme.typography.subtitle1,
    color: theme.palette.primary.contrastText,
  },
  icon: {
    color: theme.palette.primary.contrastText,
    fontSize: 30,
    marginRight: 50,
  },
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

const ReviewsModal = ({ setModalStatus, finalDeliberation, t }) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const formattedFinalDeliberation = useMemo(() => {
    const saoPauloOffset = -3 * 60; // Sao Paulo is UTC-3

    let createdDateInBrazilianTimezone = undefined;

    if (finalDeliberation.createdAt) {
      const utcDate = new Date(finalDeliberation.createdAt);
      createdDateInBrazilianTimezone = new Date(
        utcDate.getTime() + saoPauloOffset * 60 * 1000
      );
    }

    let changedDateInBrazilianTimezone = undefined;

    if (finalDeliberation.changeDate_FinalDeliberation) {
      const utcDate = new Date(finalDeliberation.changeDate_FinalDeliberation);
      changedDateInBrazilianTimezone = new Date(
        utcDate.getTime() + saoPauloOffset * 60 * 1000
      );
    }

    if (finalDeliberation?.reviews?.length < 0) {
      return {
        initialValue: {
          createdAt: new Date(finalDeliberation.createdAt),
          deliberation: finalDeliberations.find(
            (fd) => fd.id === finalDeliberation.deliberation
          ).name,
        },
        finalDeliberationHistoric: [],
      };
    }

    const lastReviewItem = {
      iD_FinalDeliberation: finalDeliberation.iD_FinalDeliberation,
      idMinuteSlot_FinalDeliberation:
        finalDeliberation.idMinuteSlot_FinalDeliberation,
      requesterReviewer_FinalDeliberation:
        finalDeliberation.requesterReviewer_FinalDeliberation,
      reviewer_FinalDeliberation: finalDeliberation.reviewer_FinalDeliberation,
      description_FinalDeliberation:
        finalDeliberation.description_FinalDeliberation,
      changeDate_FinalDeliberation: new Date(
        finalDeliberation.changeDate_FinalDeliberation
      ),
      createDate_FinalDeliberation: new Date(finalDeliberation.createdAt),
      enable_FinalDeliberation: finalDeliberation.enable_FinalDeliberation,
    };

    const newHistory = finalDeliberation?.finalDeliberationHistoric.filter(
      (item) =>
        item.iD_FinalDeliberation !==
        finalDeliberation?.finalDeliberationHistoric[
          finalDeliberation?.finalDeliberationHistoric.length - 1
        ].iD_FinalDeliberation
    );

    newHistory.push(lastReviewItem);

    let currentDeliberationCreatedDateInBrazilianTimezone = undefined;

    if (
      finalDeliberation?.finalDeliberationHistoric[
        finalDeliberation.finalDeliberationHistoric.length - 1
      ].createDate_FinalDeliberation
    ) {
      const utcDate = new Date(
        finalDeliberation?.finalDeliberationHistoric[
          finalDeliberation.finalDeliberationHistoric.length - 1
        ].createDate_FinalDeliberation
      );
      currentDeliberationCreatedDateInBrazilianTimezone = new Date(
        utcDate.getTime() + saoPauloOffset * 60 * 1000
      );
    }

    return {
      initialValue: {
        createdAt: currentDeliberationCreatedDateInBrazilianTimezone,
        deliberation: finalDeliberations.find(
          (fd) =>
            fd.id ===
            finalDeliberation?.finalDeliberationHistoric[
              finalDeliberation.finalDeliberationHistoric.length - 1
            ].description_FinalDeliberation
        ).name,
      },
      finalDeliberationHistoric: newHistory.sort(
        (a, b) =>
          new Date(a.createDate_FinalDeliberation) -
          new Date(b.createDate_FinalDeliberation)
      ),
    };
  }, [finalDeliberation]);

  return (
    <div>
      <Header>
        <span
          style={{ float: "right", cursor: "pointer" }}
          onClick={() => {
            setModalStatus(false);
          }}
        >
          [X] Fechar
        </span>
        <span className={classes.titleModal}>{t(`menu.minutes.reviews`)}</span>
      </Header>

      <ReviewsContainer>
        <Action>
          <Comment>
            <InitialRegisterTitle>{`${t(
              "forms.minutes.actions.initialRegister"
            )}:`}</InitialRegisterTitle>

            <InfoContainer>
              <Info>
                <span>{`${t("forms.minutes.actions.createdDate")}:`}</span>
                <span>
                  {formattedFinalDeliberation?.initialValue?.createdAt
                    ? format(
                        new Date(
                          formattedFinalDeliberation?.initialValue?.createdAt
                        ),
                        getDateTimeFormats(i18n.language),
                        { locale: getDateTimeLocale(i18n.language) }
                      )
                    : ""}
                </span>
              </Info>
              <Info>
                <span>{`${t(
                  "forms.minutes.actions.finalDeliberation"
                )}:`}</span>
                <span>
                  {formattedFinalDeliberation?.initialValue?.deliberation || ""}
                </span>
              </Info>
            </InfoContainer>
          </Comment>

          {formattedFinalDeliberation?.finalDeliberationHistoric?.map(
            (review) => (
              <Comment>
                <InitialRegisterTitle>Revisão:</InitialRegisterTitle>

                <InfoContainer>
                  <Info>
                    <span>{`${t("forms.minutes.actions.reviewDate")}:`}</span>
                    <span>
                      {review.createDate_FinalDeliberation
                        ? format(
                            new Date(review.createDate_FinalDeliberation),
                            getDateTimeFormats(i18n.language),
                            { locale: getDateTimeLocale(i18n.language) }
                          )
                        : ""}
                    </span>
                  </Info>

                  <Info>
                    <span>{`${t(
                      "forms.minutes.actions.reviewerRequester"
                    )}:`}</span>
                    <span>{review.requesterReviewer_FinalDeliberation}</span>
                  </Info>

                  <Info>
                    <span>{`${t("forms.minutes.actions.reviewer")}:`}</span>
                    <span>{review.reviewer_FinalDeliberation}</span>
                  </Info>
                </InfoContainer>

                <Info>
                  <span>{`${t(
                    "forms.minutes.actions.finalDeliberation"
                  )}:`}</span>
                  <span>
                    {
                      finalDeliberations.find(
                        (fd) => fd.id === review.description_FinalDeliberation
                      ).name
                    }
                  </span>
                </Info>
              </Comment>
            )
          )}
        </Action>
      </ReviewsContainer>
    </div>
  );
};

export default ReviewsModal;
